/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderCode: NonNullable<unknown> }} Station_Order_Detail_TitleInputs */

const vi_station_order_detail_title = /** @type {(inputs: Station_Order_Detail_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chi tiết đơn ${i?.orderCode}`)
};

/**

* @param {Station_Order_Detail_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_order_detail_title = /** @type {((inputs: Station_Order_Detail_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Order_Detail_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_order_detail_title(inputs)
});